module.exports = __webpack_public_path__ + "static/media/freelance.8f3fa4ae.svg";